/*
 *场景列表功能
 */

import SceneList from '../../components/sceneList';

function setSceneList(params) {
  if (!params || !params.data) return;
  this.configScenes = params;
  this.sceneList = new SceneList({
    wrapper: this.$container.get(0),
    ...params,
    onPanoClick: name => {
      this.changeSceneByName(name);
    },
  });
}

function showSceneList() {
  if (!this.sceneList) return;
  this.sceneList.show();
  if (!this.detailsList) return;
  this.detailsList.hide();
}

function hideSceneList() {
  if (!this.sceneList) return;
  this.sceneList.hide();
}

function onSceneBtnClick() {
  if (!this.sceneList) return;
  this.sceneList.toggle();
  if (!this.detailsList) return;
  this.detailsList.hide();
}

function updateSceneListByName(sceneName) {
  if (!this.sceneList) return;
  this.sceneList.changeSceneByName(sceneName);
}

export default {
  setSceneList,
  showSceneList,
  hideSceneList,
  onSceneBtnClick,
  updateSceneListByName,
};
